import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator } from '@app/modal/state-modal/state-modal.component';
import { CarrierGet, CarrierService } from '@app/services/carrier.service';
import { ProductItem, ProductService } from '@app/services/product.service';

@Component({
    selector: 'tt-carrier',
    templateUrl: './carrier.component.html',
    styleUrls: ['./carrier.component.css'],
    standalone: false,
})
export class CarrierComponent implements OnInit {
    @Input() public params?: { carrier_keyno: string };

    public page?: CarrierGet;

    public saving = false;

    constructor(
        private carrier: CarrierService,
        private product: ProductService,
        private modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {}

    public searchProducts = (params?: { value?: string }): Promise<ProductItem[]> => {
        return this.product.getProducts({ prod_name: params?.value ?? this.page?.prod_name ?? '' });
    }

    public onProductSelected(item?: Pick<ProductItem, 'item_id' | 'item_name'>): void {
        if (!this.page) return;

        this.page.prod_id = item?.item_id ?? '';
        this.page.prod_name = item?.item_name ?? '';
    }

    public onProductChanged(value: string): void {
        if (!this.page) return;

        this.page.prod_name = value;

        if (!value) this.onProductSelected();
    }

    public async save(goToProduct = false): Promise<void> {
        if (!this.page || this.saving) return;

        this.saving = true;

        try {
            const response = await this.carrier.saveCarrier(this.page);

            if (response.errorcode !== '0') {
                await this.modal.show({
                    type: 'warning',
                    title: 'error',
                    translateTitle: true,
                    message: response.errormessage
                });

                return;
            }

            if (goToProduct) {
                await this.navigator?.go({
                    to: 'product',
                    parms: { prod_id: this.page.prod_id }
                });
            } else {
                await this.navigator?.back();
            }
        } finally {
            this.saving = false;
        }
    }

    public async ngOnInit(): Promise<void> {
        const carrierKeyno = (this.navigator?.params ?? this.params)?.['carrier_keyno'];

        if (carrierKeyno !== undefined) this.page = await this.carrier.getCarrier(String(carrierKeyno));
    }
}
